<template>
  <div>
    <v-badge
      v-if="isBasket"
      :value="$store.state['app-order'].basketItemCount"
      color="error"
      offset-x="15"
      offset-y="15"
      bordered
      overlap
    >
      <v-btn
        :large="!$vuetify.breakpoint.mdAndDown"
        class="ml-3"
        style="height: 56px !important"
        depressed
        :outlined="$store.state['app-order'].basketItemCount === 0"
        rounded
        :color="
          $store.state['app-order'].basketItemCount > 0 ? 'accent' : 'primary'
        "
        dark
        @click="basketClick()"
      >
        <v-icon :size="36" class="me-2">
          {{ icons.mdiBasketOutline }}
        </v-icon>
        <div class="text-left">
          <div
            class="text-subtitle-1 text-capitalize"
            style="line-height: 1.25"
          >
            Sepet
          </div>
          <div
            v-if="$store.state['app-order'].basketItemCount > 0"
            class="text--secondary font-weight-regular"
            style="font-size: 10px"
          >
            {{ $store.state["app-order"].basketItemCount }} Ürün
          </div>
          <div
            v-else
            class="text--secondary font-weight-regular"
            style="font-size: 10px"
          >
            boş
          </div>
        </div>
      </v-btn>
    </v-badge>
  </div>
</template>

<script>
import { initialAbility } from "@/plugins/acl/config";
import store from "@/store";
import orderStoreModule from "@/views/order/orderStoreModule";
import useAppConfig from "@core/@app-config/useAppConfig";
import { useRouter } from "@core/utils";
import { mdiBasketOutline } from "@mdi/js";
import {
  getCurrentInstance,
  onMounted,
  watch,
  computed,
} from "@vue/composition-api";

export default {
  setup() {
    const vm = getCurrentInstance()?.proxy;
    const { router } = useRouter();
    const userData = JSON.parse(localStorage.getItem("userData"));

    const logoutUser = () => {
      // Remove userData from localStorage
      // ? We just removed token from localStorage. If you like, you can also make API call to backend to blacklist used token
      localStorage.removeItem("accessToken");

      // Remove userData & Ability from localStorage
      localStorage.removeItem("userData");
      localStorage.removeItem("userAbility");

      // Reset ability
      vm.$ability.update(initialAbility);

      // Redirect to login page
      router.push({ name: "auth-login" });
    };
    const { isDark } = useAppConfig();
    const PRODUCT_APP_STORE_MODULE_NAME = "app-order";

    // Register module
    if (!store.hasModule(PRODUCT_APP_STORE_MODULE_NAME)) {
      store.registerModule(PRODUCT_APP_STORE_MODULE_NAME, orderStoreModule);
    }
    const basketItem = () => store?.state["app-order"]?.basketItemCount > 0;
    const basketClick = () => {
      store.commit("app/TOGGLE_BASKET_DRAWER", true);
    };
    onMounted(() => {
      if (
        (userData.role === "PLSYR" ||
          userData.role === "DIST" ||
          userData.role === "MNGR") &&
        store.state.plasiyerCustomer === null
      ) {
      } else {
        store.dispatch("app-order/fetchBasketItemCount").then((response) => {
          if (response.error === 1) {
            logoutUser();
          }
          const dataRisk = {
            method: "riskOrderCalculate",
          };
          store.commit("RISK_LOADING", true);

          store.dispatch("postMethod", dataRisk).then((response) => {
            if (response.error == 0) {
              store.commit("RISK_TUTAR", response.detail.calculatedRisk);
              store.commit("RISK_DUR", response.detail.stopOrdering);
              store.commit("RISK_LOADING", false);
            }
          });
        });
      }
    });

    watch(
      () => store.state.plasiyerCustomer,
      () => {
        if (store.state.plasiyerCustomer) {
          store.dispatch("app-order/fetchBasketItemCount").then((response) => {
            if (response.error === 1) {
              logoutUser();
            }
          });
        }
      }
    );

    const isBasket = computed(() => {
      const result = [];

      const condition = (item) => item === true;

      vm.$ability.can("view", "asl-basket")
        ? result.push(true)
        : result.push(false);

      if (vm.$ability.can("view", "asl-customer-select")) {
        vm.$ability.can("view", "asl-customer-select")
          ? result.push(true)
          : result.push(false);

        // ŞART 2 => Kullanıcı tipine göre
        store.state.plasiyerCustomer ? result.push(true) : result.push(false);
      }

      return result.every(condition);
    });

    return {
      isDark,
      basketClick,
      basketItem,
      isBasket,
      // Icons
      icons: {
        mdiBasketOutline,
      },
    };
  },
};
</script>

<style>
.theme--dark.v-badge .v-badge__badge::after {
  border-color: #28243d !important;
}
.v-badge--bordered .v-badge__badge::after {
  border-width: 3px !important;
}
</style>
